import { TranslocoGlobalConfig } from '@jsverse/transloco-utils';

export const DEFAULT_LOCALE_CODE: LocaleCode = 'fr';
export const TRANSLOCO_LANG_STORAGE_KEY = 'translocoLang';

export type LocaleCode = 'en' | 'en-US' | 'en-GB' | 'fr' | 'es' | 'de';

const config: TranslocoGlobalConfig = {
  rootTranslationsPath: 'src/assets/i18n/',
  langs: ['fr', 'en', 'en-US', 'en-GB', 'es', 'de'],
  keysManager: {
    input: ['src/app', 'src/assets/i18n'],
  },
};

export default config;
